import * as React from "react";
import { connect } from "react-redux";

// chrome-nav imports
import { IProps as INavProps } from "../ChromeNav.d";
import * as s from "./ChromeNavContent.styles";
import { ChromeNavGeneric } from "./ChromeNavGeneric";
import { ChromeNavMenu } from "../ChromeNavMenu";
import { ChromeNavBackBtn } from "./ChromeNavBackBtn";

// other components
import { ProfileUserSummaryRenderer } from "@components/profile-user-summary";

// util
import { ChromeAppWrapperView } from "@util/chrome-extension.util";

// state
import { IReduxState } from "@reducers/root.reducer";

interface IContainer {
  environment: INavProps["environment"];
  org?: INavProps["org"];
}

interface IProps extends IContainer {
  mode: "extension" | "webapp";
}

////////////////////
// Main Component //
////////////////////

class ChromeNavCalendarProfileComponent extends React.Component<IProps> {
  public render() {
    const { org, environment, mode } = this.props;

    if (!org || !environment) {
      return (
        <ChromeNavGeneric
          backDestination={ChromeAppWrapperView.TeamHealth}
          label="Profile"
          settings
          editTeam
          feedback
        />
      );
    }

    return (
      <div style={s.calProfileContainer}>
        <div style={s.calProfileBackBtn}>
          <ChromeNavBackBtn backDestination={ChromeAppWrapperView.TeamHealth} />
        </div>
        <ProfileUserSummaryRenderer orgRelayId={org.id} environment={environment} />
        <div style={s.calProfileMenu}>
          {mode === "extension" ? <ChromeNavMenu settings feedback /> : null}
        </div>
      </div>
    );
  }
}

///////////
// Redux //
///////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    mode: state.webExtension.mode,
  };
}

export const ChromeNavCalendarProfile = connect(
  mapStateToProps,
  {},
)(ChromeNavCalendarProfileComponent);
